import React, {useEffect} from 'react'
import {Box, Grid, Typography} from "@mui/material";
import L from 'leaflet';
import {useTranslation} from "react-i18next";
import {MapContainer, Popup, TileLayer, Marker} from 'react-leaflet';
import {LatLngBoundsExpression, LatLngTuple} from "leaflet";
import 'leaflet/dist/leaflet.css';
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
const cities = require("../../data/cities.json")
const InfoPageCityLayout = (props:any) =>{
    const {language} = props
    const {t} = useTranslation()
    const germanyBounds = [
        [47.270111, 5.866342], // Southwest coordinates
        [55.057352, 15.041896], // Northeast coordinates
    ] as LatLngBoundsExpression;
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/info/city",
            type:"pageView"
        }))
    });
    const position = [51.1657, 10.4515] as LatLngTuple
        const markers:any[] = [];
        const list:any[] =[];
        if(cities && language){
            cities[language].sort((a:any, b:any) => a.name > b.name ? 1 : -1).forEach((city:any,index:number) => {
                const customMarkerIcon = L.divIcon({
                    className: 'custom-marker-icon',
                    html: `<div style="background-color: black; color: white; width: 30px; height: 30px; border-radius: 50%; display: flex; 
                    justify-content: center; align-items: center;">${index +1}</div>`,
                    iconSize: [30, 30], // Size of the icon
                });
            let imageSrc;
            try {
                imageSrc = require("../../assets/cities/"+ language +"/1991-2020/" + city.img);
            } catch (error) {
                console.warn(`Image not found for city ${city.name}: ${city.img}`);
                // Use a placeholder or skip the image
                imageSrc = null;
            }
            
            if (imageSrc) {
                markers.push(
                    <Marker key={index} position={[city.lat,city.lng]} icon={customMarkerIcon}>
                        <Popup>
                            <Box
                                component="img"
                                alt={city.name}
                                height={300}
                                src={imageSrc}
                            />
                        </Popup>
                    </Marker>
                )
            } else {
                // Still add marker but without image
                markers.push(
                    <Marker key={index} position={[city.lat,city.lng]} icon={customMarkerIcon}>
                        <Popup>
                            <Typography>{city.name}</Typography>
                        </Popup>
                    </Marker>
                )
            }
                list.push(
                    <li>{city.name}</li>
                )
            })
        }
    return(
        <div>

            <Typography style={{textAlign:"center", alignItems:"center"}}  variant="h3" gutterBottom>
                {t('info_page.city.title' as any)}
            </Typography>
            <Grid item xs={12} style={{padding: 8}}>
                <Typography>{t('info_page.city.subtitle1' as any)}</Typography>
            </Grid>
            <Grid item xs={12} style={{padding: 8}}>
                <Typography>{t('info_page.city.subtitle2' as any)}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={9}>
                        <MapContainer  style={{ height: "75vh", width: "100%" }} center={position} maxBounds={germanyBounds} zoom={6} scrollWheelZoom={true}  maxBoundsViscosity={1.0}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {markers}
                        </MapContainer>
                    </Grid>
                    <Grid item xs={3}>
                        <ol>
                            {list}
                        </ol>
                    </Grid>
                </Grid>
            </Grid>

        </div>

    )
}
export default InfoPageCityLayout
